import { useDeal } from '../../../hooks/useDeal';
import { relativeTime } from '../../../lib/utils';

interface Props { dealId: string; }

const ICONS: Record<string, string> = {
  'file-added':            '📎',
  'finding-added':         '⊕',
  'narrative-regenerated': '⟳',
  'package-version':       '§',
  'buyer-selected':        '✓',
  'buyer-contacted':       '✉',
  'lens-switched':         '↻',
  'cowork-pull':           '⌕',
  'deal-created':          '○',
  'note-added':            '✎',
};

export function ActivityTab({ dealId }: Props) {
  const { data } = useDeal(dealId);

  return (
    <>
      <div className="workspace-head">
        <div>
          <h2 className="workspace-title">Activity <em>feed</em></h2>
          <div className="workspace-subtitle">{data.activity.length} events · most recent first</div>
        </div>
      </div>

      {data.activity.length === 0 && (
        <div className="empty-state" style={{ paddingTop: 60 }}>
          <strong>No activity yet</strong>
          Events appear here as you and Claude work the deal
        </div>
      )}

      <div style={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
        {data.activity.map(e => (
          <div
            key={e.id}
            style={{
              display: 'grid', gridTemplateColumns: '36px 1fr auto',
              gap: 14, alignItems: 'center',
              padding: '12px 8px', borderBottom: '1px solid var(--border)',
            }}
          >
            <div style={{
              width: 28, height: 28, borderRadius: '50%',
              background: e.byClaude ? 'var(--accent-soft)' : 'var(--bg-card)',
              border: `1px solid ${e.byClaude ? 'rgba(201,169,110,0.3)' : 'var(--border)'}`,
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontFamily: 'var(--mono)', fontSize: 13, color: e.byClaude ? 'var(--accent)' : 'var(--text-dim)',
            }}>
              {ICONS[e.kind] ?? '·'}
            </div>
            <div>
              <div style={{ fontSize: 13, color: 'var(--text)' }}>{e.text}</div>
              <div style={{ fontFamily: 'var(--mono)', fontSize: 10, color: 'var(--text-faint)', marginTop: 2 }}>
                {e.kind.replace(/-/g, ' ')}{e.byClaude && ' · by Claude'}
              </div>
            </div>
            <div style={{ fontFamily: 'var(--mono)', fontSize: 10.5, color: 'var(--text-faint)' }}>
              {relativeTime(e.occurredAt)}
            </div>
          </div>
        ))}
      </div>
    </>
  );
}
